import React from 'react';

import cn from '@/utils/cn';

import { calloutClass, toneText } from './tone';
import { PrintLesson } from './types';

interface Props {
  lessonTitle: string | null;
  printLesson: PrintLesson | null;
}

// After analyzing, echo back the lesson the print file says it is so a wrong-file upload is caught
// before anyone trusts the diff. Success tone when it matches the selected lesson, error when it
// doesn't, and a neutral note when the file carries no lesson banner to check against.
const LessonMatchBanner = ({ lessonTitle, printLesson }: Props) => {
  const base = 'tw-mt-4 tw-flex tw-items-center tw-gap-2 tw-box-border tw-px-3 tw-py-2 tw-text-sm';

  if (!printLesson) {
    return (
      <div className={cn(calloutClass('neutral'), base, toneText.neutral)} role="status">
        <span>
          Couldn’t read a lesson banner from this file — comparing against the lesson you selected.
        </span>
      </div>
    );
  }

  const printName = `Lesson ${printLesson.number} · ${printLesson.title}`;
  const tone = printLesson.matches ? 'success' : 'error';

  return (
    <div className={cn(calloutClass(tone), base, toneText[tone])} role="status">
      <span aria-hidden="true">{printLesson.matches ? '✓' : '⚠️'}</span>
      {printLesson.matches ? (
        <span>
          Print file reads as <strong>{printName}</strong> — matches the lesson you selected.
        </span>
      ) : (
        <span>
          This file reads as <strong>{printName}</strong>, but you’re comparing against{' '}
          <strong>{lessonTitle || 'the selected lesson'}</strong>. Recheck the file or the lesson.
        </span>
      )}
    </div>
  );
};

export default LessonMatchBanner;
